<template>
  <div id="app">
    <desktop-home v-if="!isMobile"></desktop-home>
    <mobile-home v-else></mobile-home>
  </div>
</template>

<script>
import DesktopHome from './components/quizdesktop/desktopHome';
import MobileHome from './components/quizmobile/mobileHome';

export default {
  name: 'Home',
  components: {
    DesktopHome,
    MobileHome,
  },
  data() {
    return {
      isMobile: false,
    };
  },
  created() {
    if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
      this.isMobile = true;
    }
  },
};
</script>
